import React from "react"
import {
    Box,
    componentStyles,
    useTheme,
} from "@mallardbay/lib-react-components"

import LockedFeatureIcon from "~components/shared/locked-feature-icon"

export default function SidebarFeatureLockIndicator() {
    const styles = useStyles()

    return (
        <Box style={styles.featureBlocked}>
            <LockedFeatureIcon size={15} />
        </Box>
    )
}

function useStyles() {
    const { colors } = useTheme()

    return componentStyles({
        featureBlocked: {
            backgroundColor: colors.bgSecondary,
            color: colors.borderDark,
            rounded: "lg",
            padding: "4px 10px",
            marginX: "12px",
        },
    })
}
